import type { User } from '@/types';

/** Backend `detail` of a failed request, when it is a plain message. */
export function apiErrorDetail(error: unknown): string | null {
  const detail = (error as { response?: { data?: { detail?: unknown } } }).response?.data?.detail;
  return typeof detail === 'string' && detail.trim() ? detail : null;
}

/** Mirrors the backend rule: the owner, an org admin or a super admin may change knowledge sharing. */
export function canManageSharing(
  user: User | null | undefined,
  isOrganizationAdmin: boolean,
  ownerId: string | null | undefined
): boolean {
  if (isOrganizationAdmin) return true;
  return !!user?.id && !!ownerId && String(user.id) === String(ownerId);
}
